import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BsBookmarkStarFill, BsBookmarkCheckFill, BsBookmarkStar, BsBookmarkXFill } from 'react-icons/bs';
import { useQuery, useMutation } from '@apollo/client';
import { getItemList, addItemsToList, removeItemsFromList } from '../../../application/query';
import { getItemListData, setItemListId } from '../helpers';
import { useItemListId } from '../hooks';
const ItemListButton = ({
  listName,
  parent,
  modifier
}) => {
  const {
    itemId,
    itemEntity
  } = parent;
  const [isHover, setIsHover] = useState(false);
  const {
    listId
  } = useItemListId({
    listName
  });
  const getIcon = () => {
    if (isInList) return isHover ? BsBookmarkXFill : BsBookmarkCheckFill;
    return isHover ? BsBookmarkStarFill : BsBookmarkStar;
  };
  const {
    data,
    error,
    loading
  } = useQuery(getItemList, {
    variables: {
      id: listId
    },
    skip: !listId
  });
  const [addListItem] = useMutation(addItemsToList, {
    onCompleted: ({
      addItemsToList: listAddResult
    }) => {
      const {
        result: {
          id
        }
      } = listAddResult;
      if (!listId) {
        setItemListId(listName, id);
      }
    }
  });
  const [removeListItem] = useMutation(removeItemsFromList);
  const clickHandler = () => {
    setIsHover(false);
    isInList ? removeListItem({
      variables: {
        listId,
        listItems: [{
          itemId,
          itemEntity
        }]
      },
      skip: !listId
    }) : addListItem({
      variables: {
        name: listName,
        id: listId,
        listItems: [{
          itemId,
          itemEntity
        }]
      },
      skip: !listId
    });
  };
  if (loading) return '';
  if (error) return error.message;
  const listItems = getItemListData(data);
  const isInList = !!listItems.find(({
    itemId: idToCheck,
    itemEntity: entityToCheck
  }) => idToCheck === itemId && entityToCheck === itemEntity);
  const Icon = getIcon();
  const stateClassName = isInList ? 'item-list-button--selected' : '';
  const className = ['item-list-button', stateClassName, modifier].filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    role: "button",
    onClick: clickHandler,
    onMouseEnter: () => setIsHover(true),
    onMouseLeave: () => setIsHover(false),
    "aria-label": `Add to ${listName}`
  }, /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(Icon, null)));
};
ItemListButton.propTypes = {
  parent: PropTypes.object,
  listName: PropTypes.string,
  modifier: PropTypes.string
};
ItemListButton.defaultProps = {
  parent: {},
  listName: '',
  modifier: ''
};
export default ItemListButton;
//# sourceMappingURL=ItemListButton.js.map